const linksOption = [
    {href: '/companies', title: 'Companies'},
    {href: '/team', title: 'People'},
    {href: '/podcasts/running-through-walls', title: 'Podcasts'},
    {href: '/insights', title: 'Insights'},
    {href: '/contact', title: 'Contact'},
    {href: 'https://jobs.venrock.com/jobs', title: 'Careers', external: true},
];

const socialMediaOption = [
    {href: 'https://www.linkedin.com/company/venrock', title: 'LinkedIn'},
    {href: 'https://twitter.com/Venrock', title: 'Twitter'},
];
export default linksOption;
export {socialMediaOption};
